import React, { useEffect, useState } from "react";
import "./myOrderDetails.scss";
import userActivePage from "../../../../store/userActivePage";
import orderStore from "../../../../store/orderStore";
import paymentStore from "../../../../store/paymentStore";
import {
  Button,
  Divider,
  Rating,
  Stack,
  Collapse,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import productStore from "../../../../store/productStore";
import { PRODUCT_IMAGE_URL } from "../../../../constant";
import addressStore from "../../../../store/addressStore";
import MyOrderProductSkeleton from "./myOrderSkeleton/MyOrderProductSkeleton";
import MyOrderReturnRatingSkeleton from "./myOrderSkeleton/MyOrderReturnRatingSkeleton";
import MyOrderAddressSkeleton from "./myOrderSkeleton/MyOrderAddressSkeleton";
import MyOrderPaymentSkeleton from "./myOrderSkeleton/MyOrderPaymentSkeleton";
import categoryStore from "../../../../store/categoryStore";
import orderDeliveryStatusTimeStore from "../../../../store/orderDeliveryStatusTimeStore";
import dateFormat from "dateformat";

// Time Line
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
// Time Line

// Icon
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import { MdOutlinePending } from "react-icons/md";
import { ImMakeGroup } from "react-icons/im";
import { GiStorkDelivery, GiReturnArrow } from "react-icons/gi";
import { BsBox2Fill } from "react-icons/bs";
import StarRateRoundedIcon from "@mui/icons-material/StarRateRounded";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import productRatingStore from "../../../../store/productRatingStore";
import ProductRatingDialog from "../../../../components/productRatingDialog/ProductRatingDialog";
import brandStore from "../../../../store/brandStore";

import { jsPDF } from "jspdf";
import { YsabeauOffice } from "../../../../assets/font/Fonts";
import orderReturnRequestStore from "../../../../store/orderReturnRequestStore";
import { LoadingButton } from "@mui/lab";

const MyOrderDetails = () => {
  const navigate = useNavigate();
  const UserActivePage = userActivePage();
  const params = useParams();
  const OrderStore = orderStore();
  const PaymentStore = paymentStore();
  const ProductStore = productStore();
  const CategoryStore = categoryStore();
  const AddressStore = addressStore();
  const OrderDeliveryStatusTimeStore = orderDeliveryStatusTimeStore();
  const ProductRatingStore = productRatingStore();
  const BrandStore = brandStore();
  const OrderReturnRequestStore = orderReturnRequestStore();

  const [myOrderDetails, setMyOrderDetails] = useState(null);
  const [product, setProduct] = useState(null);
  const [allOrderProduct, setAllOrderProduct] = useState(null);
  const [deliveryStatusIcon, setDeliveryStatusIcon] = useState();
  const [paymentID, setPaymentID] = useState(null);
  const [paymentType, setPaymentType] = useState(null);
  const [paymentData, setPaymentData] = useState(null);
  const [addressData, setAddressData] = useState(null);
  const [navigateToProduct, setNavigateToProduct] = useState(null);
  const [orderStatusDetail, setOrderStatusDetail] = useState(null);
  const [expanded, setExpanded] = useState(false);

  const [ratingValue, setRatingValue] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [alreadyRating, setAlreadyRating] = useState(false);

  const [deliveryDate, setDeliveryDate] = useState();
  const [returnAvailable, setReturnAvailable] = useState(false);

  const [returnDialogOpen, setReturnDialogOpen] = useState(false);
  const [returnDialogLoading, setReturnDialogLoading] = useState(false);
  const [whyReturn, setWhyReturn] = useState("");
  const [returningProcess, setReturningProcess] = useState(null);

  useEffect(() => {
    UserActivePage.setIsActive({ setPage: "my-orders" });
    window.scrollTo({ top: 0 });
  }, []);

  useEffect(() => {
    if (OrderStore.orderDetails && !OrderReturnRequestStore.isLoading) {
      for (let i = 0; i < OrderStore.orderDetails.length; i++) {
        if (OrderStore.orderDetails[i]._id === params.id) {
          setMyOrderDetails(OrderStore.orderDetails[i]);
          OrderDeliveryStatusTimeStore.orderDeliveryStatusTime.map((status) => {
            if (
              status._id ===
              OrderStore.orderDetails[i].orderDeliveryStatusTimeID
            ) {
              setOrderStatusDetail(status);
              if (
                OrderStore.orderDetails[i].order_delivery_status === "Pending"
              ) {
                setDeliveryStatusIcon(<MdOutlinePending className="icon" />);
              } else if (
                OrderStore.orderDetails[i].order_delivery_status === "Preparing"
              ) {
                setDeliveryStatusIcon(<ImMakeGroup className="icon" />);
              } else if (
                OrderStore.orderDetails[i].order_delivery_status ===
                "Out Of Delivery"
              ) {
                setDeliveryStatusIcon(<GiStorkDelivery className="icon" />);
              } else if (
                OrderStore.orderDetails[i].order_delivery_status === "Delivered"
              ) {
                setDeliveryStatusIcon(<BsBox2Fill className="icon" />);
                var myDate = new Date(status.delivered);
                myDate.setDate(myDate.getDate() + 2);
                setDeliveryDate(myDate);
                const today = new Date();
                if (myDate >= today) {
                  setReturnAvailable(true);
                }
              } else if (
                OrderStore.orderDetails[i].order_delivery_status === "Return"
              ) {
                setDeliveryStatusIcon(<GiReturnArrow className="icon" />);
                setReturnAvailable(true);
              }
              return;
            }
          });

          if (ProductStore.mProduct) {
            for (let j = 0; j < ProductStore.mProduct.length; j++) {
              if (
                ProductStore.mProduct[j]._id ===
                OrderStore.orderDetails[i].productID
              ) {
                setProduct(ProductStore.mProduct[j]);
                break;
              }
            }
          }

          setPaymentID(OrderStore.orderDetails[i].paymentID);

          if (OrderReturnRequestStore.orderReturnRequest) {
            OrderReturnRequestStore.orderReturnRequest.map((item) => {
              if (item.orderID === OrderStore.orderDetails[i]._id) {
                setReturningProcess(item);
              }
            });
          }
        }
      }
    }
  }, [!OrderStore.isLoading, OrderReturnRequestStore.isLoading]);

  useEffect(() => {
    if (!PaymentStore.isLoading) {
      for (let i = 0; i < PaymentStore.paymentDetails.length; i++) {
        if (PaymentStore.paymentDetails[i]._id === paymentID) {
          const oProduct = [];
          for (let o = 0; o < OrderStore.orderDetails.length; o++) {
            if (
              OrderStore.orderDetails[o].paymentID ===
              PaymentStore.paymentDetails[i]._id
            ) {
              for (let p = 0; p < ProductStore.mProduct.length; p++) {
                if (
                  ProductStore.mProduct[p]._id ===
                  OrderStore.orderDetails[o].productID
                ) {
                  oProduct.push({
                    _id: OrderStore.orderDetails[o]._id,
                    productID: OrderStore.orderDetails[o].productID,
                    paymentID: OrderStore.orderDetails[o].paymentID,
                    productImage: ProductStore.mProduct[p].productImages[0],
                    productName: ProductStore.mProduct[p].productName,
                    qty: OrderStore.orderDetails[o].quantity,
                    price: OrderStore.orderDetails[o].purchasePrice,
                  });
                }
              }
            }
          }
          setAllOrderProduct(oProduct);
        }
      }
    }
  }, [PaymentStore.isLoading, paymentID]);

  useEffect(() => {
    if (product) {
      for (let i = 0; i < CategoryStore.mCategory.length; i++) {
        if (CategoryStore.mCategory[i]._id === product.categoryID) {
          setNavigateToProduct(
            `/${CategoryStore.mCategory[i].categoryName}/${product.productName?.trim().toLowerCase().replaceAll(" ", "-")}/${product._id}/details`
          );
        }
      }
      if (!ProductRatingStore.isLoadingUser) {
        if (ProductRatingStore.myReview) {
          ProductRatingStore.myReview.map((r) => {
            if (r.productID === product._id) {
              setRatingValue(r.rating);
              setAlreadyRating(true);
            }
          });
        }
      }
    }
  }, [product, ProductRatingStore.isLoadingUser]);

  useEffect(() => {
    if (PaymentStore.paymentDetails && paymentID && AddressStore.myAddress) {
      for (let i = 0; i < PaymentStore.paymentDetails.length; i++) {
        if (PaymentStore.paymentDetails[i]._id === paymentID) {
          setPaymentData(PaymentStore.paymentDetails[i]);
          setPaymentType(PaymentStore.paymentDetails[i].paymentType);
          for (let j = 0; j < AddressStore.myAddress.length; j++) {
            if (
              PaymentStore.paymentDetails[i].addressID ===
              AddressStore.myAddress[j]._id
            ) {
              setAddressData(AddressStore.myAddress[j]);
              break;
            }
          }
        }
      }
    }
  }, [paymentID]);

  const DownloadBill = () => {
    const doc = new jsPDF();

    doc.addFileToVFS("YsabeauOffice-Thin-normal.ttf", YsabeauOffice);
    doc.addFont(
      "YsabeauOffice-Thin-normal.ttf",
      "YsabeauOffice",
      "normal",
      200
    );

    doc.addFileToVFS("YsabeauOffice-VariableFont_wght-bold.ttf", YsabeauOffice);
    doc.addFont(
      "YsabeauOffice-VariableFont_wght-bold.ttf",
      "YsabeauOffice",
      "bold"
    );

    doc.setFont("YsabeauOffice", "bold");
    doc.setFontSize(30);
    doc.text(`${BrandStore.brand.brandName}`, 10, 30);

    doc.setFontSize(12);
    doc.setTextColor(100);
    doc.setFont("YsabeauOffice", "normal");
    doc.text("Bill of Supply / Cash Memo", 200, 20, null, null, "right");
    doc.text("(Original for Recipient)", 200, 25, null, null, "right");

    doc.setTextColor(0);
    doc.setFont("YsabeauOffice", "bold");
    doc.text(
      `Bill Date: ${dateFormat(
        new Date(myOrderDetails.order_at),
        "dd mmm yyyy"
      )}`,
      200,
      35,
      null,
      null,
      "right"
    );

    doc.setFont("YsabeauOffice", "normal");

    doc.setTextColor(100);
    doc.setFontSize(9);
    doc.text("Price In INR", 200, 45, null, null, "right");

    doc.setFontSize(12);
    doc.setDrawColor(150);
    doc.setLineWidth(0.2);
    doc.line(0, 50, 220, 50);

    doc.setTextColor(0);
    doc.setFont("YsabeauOffice", "bold");
    doc.text("Our Address", 10, 65);

    doc.setFont("YsabeauOffice", "normal");
    doc.setTextColor(100);
    doc.text(`${BrandStore.brand.brandName}`, 10, 72);
    doc.text(`${BrandStore.brand.brandAddress}`, 10, 77);
    doc.text(`${BrandStore.brand.brandContactUs}`, 10, 82);

    doc.setFont("YsabeauOffice", "bold");
    doc.setTextColor(0);
    doc.text("Shipping Address", 200, 65, null, null, "right");

    doc.setFont("YsabeauOffice", "normal");
    doc.setTextColor(100);
    doc.text(`${addressData.fullName}`, 200, 72, null, null, "right");
    doc.text(`${addressData.address}`, 200, 77, null, null, "right");
    doc.text(
      `${addressData.city}, ${addressData.state} - ${addressData.pincode}`,
      200,
      82,
      null,
      null,
      "right"
    );
    doc.text(`${addressData.phoneNumber}`, 200, 87, null, null, "right");

    doc.setLineWidth(0.1);
    doc.line(10, 100, 200, 100);
    doc.setTextColor(0);
    doc.setFont("YsabeauOffice", "bold");

    doc.text("S.No", 20, 106, { maxWidth: 10 });
    doc.text("Item", 40, 106, { maxWidth: 80 });
    doc.text("QTY", 130, 106, { maxWidth: 10 });
    doc.text("Price", 150, 106, { maxWidth: 20 });
    doc.text("Amount", 180, 106, { maxWidth: 20 });

    doc.setLineWidth(0.1);
    doc.line(10, 110, 200, 110);

    doc.setTextColor(100);
    doc.setFont("YsabeauOffice", "normal");

    var line = 117;

    for (var i = 0; i < allOrderProduct.length; i += 1) {
      let sno = i + 1;
      doc.text(`${sno}`, 20, line, { maxWidth: 10 });
      doc.text(`${allOrderProduct[i].productName}`, 40, line, {
        maxWidth: 80,
      });
      doc.text(`${allOrderProduct[i].qty}`, 130, line, { maxWidth: 10 });
      doc.text(`${allOrderProduct[i].price}`, 150, line, {
        maxWidth: 20,
      });
      doc.text(
        `${allOrderProduct[i].qty * allOrderProduct[i].price}`,
        180,
        line,
        {
          maxWidth: 20,
        }
      );
      line = line + 6;
    }

    line = line + 10;
    doc.text("Subtotal", 170, line, null, null, "right");
    doc.text(` ${paymentData.subTotal}`, 195, line, null, null, "right");

    line = line + 5;
    doc.text("Discount", 170, line, null, null, "right");
    doc.text(`${paymentData.discount}`, 195, line, null, null, "right");

    if (paymentData.couponDiscount !== 0) {
      line = line + 5;
      doc.text("Coupon Discount", 170, line, null, null, "right");
      doc.text(`${paymentData.couponDiscount}`, 195, line, null, null, "right");
    }

    line = line + 5;
    doc.text("Shipping", 170, line, null, null, "right");
    doc.text("Free", 195, line, null, null, "right");

    doc.setFont("YsabeauOffice", "bold");
    doc.setFontSize(15);
    doc.setTextColor(0);

    line = line + 10;
    doc.text("Total", 170, line, null, null, "right");
    doc.text(`${paymentData.total}`, 195, line, null, null, "right");

    doc.setFont("YsabeauOffice", "normal");
    doc.setFontSize(13);

    doc.setLineWidth(0.1);
    doc.line(0, 280, 220, 280);
    doc.text(
      `Thank you for ordering with ${BrandStore.brand.brandName}.`,
      10,
      290
    );

    doc.save("bill.pdf");
  };

  // useEffect(() => {
  //   if (myOrderDetails && !OrderReturnRequestStore.isLoading) {
  //     if (OrderReturnRequestStore.orderReturnRequest) {
  //       OrderReturnRequestStore.orderReturnRequest.map((item) => {
  //         if (item.orderID === myOrderDetails._id) {
  //           console.log(item);
  //           setReturningProcess(item);
  //         }
  //       });
  //     }
  //   }
  // }, [myOrderDetails, OrderReturnRequestStore.isLoading]);

  const returnProduct = async () => {
    setReturnDialogLoading(true);
    // await OrderStore.updateOrderStatusForReturn({ paymentID });
    await OrderReturnRequestStore.createOrderReturnRequest({
      whyReturn,
      orderID: myOrderDetails._id,
      paymentID,
    });

    setReturnDialogLoading(false);
    handleReturnDialogClose();
  };

  const handleReturnDialogClose = () => {
    setReturnDialogOpen(false);
  };

  return (
    <div className="my-order-details">
      <div className="back-button">
        <Button
          startIcon={<ArrowBackIosRoundedIcon className="icon" />}
          className="btn"
          onClick={() => navigate(-1)}
        >
          <p>Back</p>
        </Button>
        {orderStatusDetail &&
          orderStatusDetail.returning === null &&
          orderStatusDetail.delivered && (
            <Button className="btn" onClick={DownloadBill}>
              <p>Download Bill</p>
            </Button>
          )}
      </div>
      {/* Return Dialog */}
      <Dialog
        open={returnDialogOpen}
        onClose={handleReturnDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure want to return product?"}
        </DialogTitle>
        <DialogContent>
          <p style={{ fontWeight: 500, color: "var(--textColor)" }}>
            If you don't mind, you tell me to why are you return a product?
          </p>
          <TextField
            fullWidth
            name="whtReturn"
            multiline
            rows={2}
            sx={{ mt: 2 }}
            value={whyReturn}
            label="Why Return (optional)"
            onChange={(e) => setWhyReturn(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReturnDialogClose}>Cancel</Button>
          <LoadingButton
            loading={returnDialogLoading}
            onClick={returnProduct}
            autoFocus
          >
            Return Product
          </LoadingButton>
        </DialogActions>
      </Dialog>
      {/* Return Dialog */}
      <Stack spacing={2} className="main-contain">
        {myOrderDetails ? (
          <Stack spacing={2} className="my-order-product-details">
            <img
              src={product && `${PRODUCT_IMAGE_URL}${product.productImages[0]}`}
              alt="product-img"
              className="product-img"
              onClick={() => navigateToProduct && navigate(navigateToProduct)}
            />
            <div className="product-basic-details">
              <div className="product-name">
                {product && product.productName}
              </div>
              <div className="product-description">
                {product && product.productSubDescription}
              </div>
              {/* <div className="product-size">
                Size: {myOrderDetails && myOrderDetails.selectedSize}
              </div>
              <div className="product-color">
                Color:{" "}
                {myOrderDetails && myOrderDetails.selectedColor.toString()}
              </div> */}
            </div>

            <Stack
              spacing={2}
              direction="row"
              className="delivery-status-container"
            >
              {deliveryStatusIcon && deliveryStatusIcon}
              <div className="content">
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <div className="delivery-status">
                      {myOrderDetails &&
                      myOrderDetails.order_delivery_status === "Return"
                        ? myOrderDetails.order_delivery_status + "ed"
                        : myOrderDetails.order_delivery_status}
                    </div>
                    <div className="delivery-date">
                      {myOrderDetails &&
                      myOrderDetails.order_delivery_status === "Pending"
                        ? "Wait for Owner accept - within 24 hours"
                        : orderStatusDetail.returning
                        ? dateFormat(
                            new Date(orderStatusDetail.returning),
                            "dd mmm yyyy - hh:MM TT"
                          )
                        : orderStatusDetail.delivered
                        ? dateFormat(
                            new Date(orderStatusDetail.delivered),
                            "dd mmm yyyy - hh:MM TT"
                          )
                        : orderStatusDetail.out_of_delivery
                        ? dateFormat(
                            new Date(orderStatusDetail.out_of_delivery),
                            "dd mmm yyyy - hh:MM TT"
                          )
                        : orderStatusDetail.preparing &&
                          `${dateFormat(
                            new Date(orderStatusDetail.preparing),
                            "dd mmm yyyy - hh:MM TT"
                          )} and Delivery within ${
                            product && product.deliverDays
                          }`}
                    </div>
                  </div>
                  <div className="expanded-btn">
                    <IconButton onClick={() => setExpanded(!expanded)}>
                      <ExpandMoreIcon
                        style={{
                          transition: "all 0.5s ease",
                          transform: !expanded
                            ? "rotate(0deg)"
                            : "rotate(180deg)",
                        }}
                      />
                    </IconButton>
                  </div>
                </div>
                <div className="timeline">
                  <Collapse
                    className="collapse"
                    in={expanded}
                    timeout="auto"
                    unmountOnExit
                  >
                    <Timeline
                      sx={{
                        [`& .${timelineItemClasses.root}:before`]: {
                          flex: 0,
                          padding: 0,
                        },
                        transition: "all 0.5s ease",
                      }}
                    >
                      {orderStatusDetail.returning && (
                        <TimelineItem>
                          <TimelineSeparator>
                            <TimelineDot
                              className={
                                orderStatusDetail.returning && "active-dot-bar"
                              }
                            />
                            <TimelineConnector
                              className={
                                orderStatusDetail.returning && "active-dot-bar"
                              }
                            />
                          </TimelineSeparator>
                          <TimelineContent>
                            <div>
                              <div
                                className={`status-title ${
                                  orderStatusDetail.returning && "active-status"
                                }`}
                              >
                                Return
                              </div>
                              <div className="date-time">
                                {orderStatusDetail.returning &&
                                  dateFormat(
                                    new Date(orderStatusDetail.returning),
                                    "dd mmm yyyy - hh:MM TT"
                                  )}
                              </div>
                            </div>
                          </TimelineContent>
                        </TimelineItem>
                      )}
                      <TimelineItem>
                        <TimelineSeparator>
                          <TimelineDot
                            className={
                              orderStatusDetail.delivered && "active-dot-bar"
                            }
                          />
                          <TimelineConnector
                            className={
                              orderStatusDetail.delivered && "active-dot-bar"
                            }
                          />
                        </TimelineSeparator>
                        <TimelineContent>
                          <div>
                            <div
                              className={`status-title ${
                                orderStatusDetail.delivered && "active-status"
                              }`}
                            >
                              Delivered
                            </div>
                            <div className="date-time">
                              {orderStatusDetail.delivered &&
                                dateFormat(
                                  new Date(orderStatusDetail.delivered),
                                  "dd mmm yyyy - hh:MM TT"
                                )}
                            </div>
                          </div>
                        </TimelineContent>
                      </TimelineItem>
                      <TimelineItem>
                        <TimelineSeparator>
                          <TimelineDot
                            className={
                              orderStatusDetail.out_of_delivery &&
                              "active-dot-bar"
                            }
                          />
                          <TimelineConnector
                            className={
                              orderStatusDetail.out_of_delivery &&
                              "active-dot-bar"
                            }
                          />
                        </TimelineSeparator>
                        <TimelineContent>
                          <div>
                            <div
                              className={`status-title ${
                                orderStatusDetail.out_of_delivery &&
                                "active-status"
                              }`}
                            >
                              Out Of Delivery
                            </div>
                            <div className="date-time">
                              {orderStatusDetail.out_of_delivery &&
                                dateFormat(
                                  new Date(orderStatusDetail.out_of_delivery),
                                  "dd mmm yyyy - hh:MM TT"
                                )}
                            </div>
                          </div>
                        </TimelineContent>
                      </TimelineItem>
                      <TimelineItem>
                        <TimelineSeparator>
                          <TimelineDot
                            className={
                              orderStatusDetail.preparing && "active-dot-bar"
                            }
                          />
                          <TimelineConnector
                            className={
                              orderStatusDetail.preparing && "active-dot-bar"
                            }
                          />
                        </TimelineSeparator>
                        <TimelineContent>
                          <div>
                            <div
                              className={`status-title ${
                                orderStatusDetail.preparing && "active-status"
                              }`}
                            >
                              Preparing
                            </div>
                            <div className="date-time">
                              {orderStatusDetail.preparing &&
                                dateFormat(
                                  new Date(orderStatusDetail.preparing),
                                  "dd mmm yyyy - hh:MM TT"
                                )}
                            </div>
                          </div>
                        </TimelineContent>
                      </TimelineItem>
                      <TimelineItem>
                        <TimelineSeparator>
                          <TimelineDot className="active-dot-bar" />
                        </TimelineSeparator>
                        <TimelineContent>
                          <div>
                            <div className="status-title active-status">
                              Pending
                            </div>
                            <div className="date-time">
                              {orderStatusDetail.pending &&
                                dateFormat(
                                  new Date(orderStatusDetail.pending),
                                  "dd mmm yyyy - hh:MM TT"
                                )}
                            </div>
                          </div>
                        </TimelineContent>
                      </TimelineItem>
                    </Timeline>
                  </Collapse>
                </div>
              </div>
            </Stack>
          </Stack>
        ) : (
          <MyOrderProductSkeleton />
        )}

        {myOrderDetails && !OrderReturnRequestStore.isLoading ? (
          (myOrderDetails.order_delivery_status === "Delivered" ||
            myOrderDetails.order_delivery_status === "Return") && (
            <>
              {process.env.REACT_APP_RETURN_ACCEPT == true && (
                <div className="return-product">
                  {returnAvailable ? (
                    <div className="is-return">
                      {returningProcess ? (
                        returningProcess.is_return_cancel ? (
                          "Your return order has cancel on " +
                          dateFormat(
                            returningProcess.cancel_return_date,
                            "dd mmm yyyy"
                          )
                        ) : returningProcess.order_returning_status === false &&
                          returningProcess.order_return_status === false ? (
                          <p>Returning process start within 24 hours.</p>
                        ) : returningProcess.order_returning_status === true &&
                          returningProcess.order_return_status === false ? (
                          <p>We will pick up return order within 7 days.</p>
                        ) : returningProcess.order_returning_status === false &&
                          returningProcess.order_return_status === true ? (
                          <p>
                            The product has returned successfully on{" "}
                            {dateFormat(
                              returningProcess.order_return_at,
                              "dd mmm yyyy"
                            )}
                            .
                          </p>
                        ) : (
                          ""
                        )
                      ) : (
                        <>
                          <p>
                            Return til{" "}
                            {orderStatusDetail &&
                              dateFormat(deliveryDate, "dd mmm yyyy")}
                          </p>
                          <Button
                            className="btn"
                            size="small"
                            onClick={() => setReturnDialogOpen(true)}
                          >
                            Return
                          </Button>
                        </>
                      )}
                    </div>
                  ) : (
                    <p>
                      Return window closed on{" "}
                      {orderStatusDetail &&
                        dateFormat(deliveryDate, "dd mmm yyyy")}
                    </p>
                  )}
                </div>
              )}
              <div className="product-rating">
                <p>Rate Product</p>
                <Rating
                  name="order-product-rating"
                  className="order-product-rating"
                  icon={<StarRateRoundedIcon fontSize="inherit" />}
                  emptyIcon={<StarOutlineRoundedIcon fontSize="inherit" />}
                  value={ratingValue}
                  readOnly={alreadyRating}
                  onChange={(event, newValue) => {
                    setRatingValue(newValue);
                    if (newValue !== null) {
                      setOpenDialog(true);
                    }
                  }}
                />
              </div>
              <ProductRatingDialog
                openDialog={openDialog}
                setOpenDialog={setOpenDialog}
                ratingValue={ratingValue}
                setRatingValue={setRatingValue}
                productID={product._id}
              />
            </>
          )
        ) : (
          <MyOrderReturnRatingSkeleton />
        )}

        {myOrderDetails && (
          <div>
            <div className="order-id">
              <b>Order ID:</b> {paymentID && paymentID}
            </div>
            <div className="order-date">
              <b>Order Date:</b>{" "}
              {dateFormat(myOrderDetails.order_at, "dd mmm yyyy HH:MM:ss")}
            </div>
          </div>
        )}

        {addressData ? (
          <Stack spacing={2} className="delivery-address">
            <div className="title">Delivery Address</div>
            <div className="user-delivery-details">
              <div className="name-and-contact">
                <div className="name">{addressData.fullName}</div>
                <Divider orientation="vertical" flexItem />
                <div className="contact-no">{addressData.phoneNumber}</div>
              </div>
              <div className="user-delivery-address">
                {addressData.address}, {addressData.city} -{" "}
                {addressData.pincode}
              </div>
            </div>
          </Stack>
        ) : (
          <MyOrderAddressSkeleton />
        )}

        {paymentData ? (
          <Stack spacing={2} className="payment-information">
            <div className="title">Payment Information</div>
            <div className="content">
              <div className="order-payment-type">Paid by {paymentType}</div>
              {allOrderProduct &&
                allOrderProduct.map((order) => {
                  if (order.paymentID === paymentID) {
                    return ProductStore.mProduct.map((product) => {
                      if (product._id === order.productID) {
                        return (
                          <div className="product-list" key={product._id}>
                            <div className="product-name-and-qty">
                              {order.qty} x {product.productName}
                            </div>
                            <div className="product-price">
                              {product.regularPrice === order.price ? (
                                <p className="regular-price">
                                  ₹{product.regularPrice * order.qty}
                                </p>
                              ) : (
                                <>
                                  <p className="regular-price-line-through">
                                    ₹{product.regularPrice * order.qty}
                                  </p>
                                  <p className="order-price">
                                    ₹{order.price * order.qty}
                                  </p>
                                </>
                              )}
                            </div>
                          </div>
                        );
                      }
                    });
                  }
                })}

              <div className="sub-total-price column-item">
                <div className="label">Sub Total Price</div>
                <div className="price">₹{paymentData.subTotal}</div>
              </div>
              <div className="discount-price column-item">
                <div className="label">Discounted Price</div>
                <div className="price">₹{paymentData.discount}</div>
              </div>
              {paymentData.couponDiscount !== 0 && (
                <div className="coupon-discount-price column-item">
                  <div className="label">Coupon Discounted Price</div>
                  <div className="price">₹{paymentData.couponDiscount}</div>
                </div>
              )}
              <div className="shipping-price column-item">
                <div className="label">Shipping</div>
                <div className="price">Free</div>
              </div>
              <div className="total-price column-item">
                <div className="label">Total Price</div>
                <div className="price">₹{paymentData.total}</div>
              </div>
            </div>
          </Stack>
        ) : (
          <MyOrderPaymentSkeleton />
        )}
      </Stack>
    </div>
  );
};

export default MyOrderDetails;
